
import { Component, Vue, Prop } from 'vue-property-decorator';
import type { Field } from '@/shared/types/aperTemplate';

@Component
export default class MultiTextFieldPreview extends Vue {
  @Prop({ type: Object, required: true }) readonly field!: Field;

  get hasTextTemplates(): boolean | undefined {
    return this.field.textTemplates && this.field.textTemplates.length > 0;
  }
}
